'use strict';

/* global angular */

const RavenService = require('./RavenService');
const Raven = require('raven-js');

const raven = angular.module('common.raven', [
  'common.identity'
]);

raven.service('RavenService', RavenService);

raven.config(['$provide', function ($provide) {
  // This section connects Raven with angular $exceptionHandler so everything that
  // is caught by it will get reported to Sentry.
  // This code is basically the entirety of https://github.com/bendrucker/ng-raven
  // without the hard-version dependency to raven <=2, so we can keep up to date
  $provide.decorator('$exceptionHandler', [
    '$delegate',
    function ($exceptionHandler) {
      return function (err, cause) {
        $exceptionHandler(err, cause);

        if (RavenService._RAVEN_DSN) {
          Raven.captureException(err, { extra: { cause: cause }});
        }
      };
    }
  ]);
}]);

raven.run(['IdentityService', function(IdentityService) {

  RavenService._RAVEN_DSN = IdentityService.get('sentryDSN');
  var appInfo = IdentityService.get('appInfo');
  var tags = {};

  if (!RavenService._RAVEN_DSN) {
    return;
  }

  if (appInfo.env.match(/^dev/)) {
    tags.env = 'development';
  }
  else if (appInfo.env.match(/^staging/)) {
    tags.env = 'staging';
  }

  Raven
  .config(RavenService._RAVEN_DSN, {
    logger: 'javascript',
    environment: appInfo.env,
    tags: tags
    // release: 'master-abcdef', // TODO: Add release version, either here or in tags
    // dataCallback: (data) => {
    //   // Do some preprocessing to data
    //   return data;
    // }
  })
  .addPlugin(require('raven-js/plugins/angular'), angular)
  .install();
}]);

module.exports = RavenService;


// WEBPACK FOOTER //
// ./src/common/raven/index.js